import Text from "../../../../../palette/Text";
import Button from '@material-ui/core/Button';
import Seating from "./Seating";
import hands from "../../../../../assets/img/hands.png"
import VerticalSpace from "../../../../../palette/VerticalSpace";

function Topology() {

    return (
        <div className="topology">
           {/*<VerticalSpace space={28}/>*/}
            <Text hover={false} weight={'700'} size={14} color={'#19598D'} text={'Descripción'}/>
            <VerticalSpace space={10}/>
            <img src={hands} alt={''} style={{width: 50, height: 50}}/>
            <Button disableElevation style={{width: 50, height: 50}} disabled={true}>
                <Seating text={'Chofer'} color={'red'} seatColor={'#FFF2BF'} textColor={'black'}/>
            </Button>
            <VerticalSpace space={10}/>
            <Button disableElevation style={{width: 50, height: 50}} disabled={true}>
                <Seating text={'Disponible'} color={'#029FEB'} seatColor={'#FFF2BF'} textColor={'black'}/>
            </Button>
            <VerticalSpace space={10}/>
            <Button disableElevation style={{width: 50, height: 50}} disabled={true}>
                <Seating text={'Reservado'} color={'green'} seatColor={'#FFF2BF'} textColor={'black'}/>
            </Button>
            <VerticalSpace space={10}/>
            <Button disableElevation style={{width: 50, height: 50}} disabled={true}>
                <Seating text={'Desabilitado'} color={'#90A4AE'} seatColor={'#B0BEC5'} textColor={'white'}/>
            </Button>
        </div>

    )
}

export default Topology